<template>
  <div class="qualityContain">
    <div class="typeCon">
      <el-radio-group v-model="period" size="medium" @change="periodChange">
        <el-radio-button label="0">碾压遍数</el-radio-button>
        <el-radio-button label="1">压实度</el-radio-button>
        <el-radio-button label="2">碾压温度</el-radio-button>
        <el-radio-button label="3">轨迹</el-radio-button>
      </el-radio-group>
    </div>
    <div class="traceCon" v-if="!typeShow">
      <RollingTrace
        :workId="workId"
        :activeIndex1Code="activeIndex1"
        :workName="workName"
      ></RollingTrace>
    </div>

    <div class="timeContain" v-if="typeShow">
      <!-- <label class="group-label">时间段</label> -->
      <el-date-picker
        size="medium"
        v-model="duration"
        @change="dateChange"
        type="daterange"
        range-separator="—"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-button class="searchBtn" type="primary" @click="searchBtn"
        >确认</el-button
      >
    </div>

    <div class="blockHeader" v-if="typeShow">
      <div class="redBlock"></div>
      <div class="headerText">云图</div>
    </div>
    <div class="imgContent" v-if="typeShow">
      <el-button type="primary" class="checkDetail" @click="showDetail"
        >查看详情</el-button
      >
      <RollLegend
        v-show="period == 0"
        class="rollLegend"
        fontColor="black"
        legendType="1"
        @childExam="getRnExam"
      ></RollLegend>
      <RollLegend
        v-show="period == 1"
        class="rollLegend"
        fontColor="black"
        legendType="2"
        @childExam="getIcvExam"
      ></RollLegend>
      <RollLegend
        v-show="period == 2"
        class="rollLegend"
        fontColor="black"
        legendType="4"
        @childExam="getIcvExam"
      ></RollLegend>
      <el-image
        style="width: 100%; height: 97%"
        :src="imageUrl"
        fit="scale-down"
        :preview-src-list="srcList"
      >
        <div slot="error" class="image-slot">暂无数据</div>
      </el-image>
    </div>
    <div class="blockHeader" v-if="typeShow">
      <div class="redBlock"></div>
      <div class="headerText">数据分析</div>
    </div>
    <div class="infoContain" v-if="typeShow">
      <div class="infoL">
        <LeftList :data="leftData" :keyMap="keyMap" />
      </div>
      <div class="infoR">
        <div class="typeCon">
          <el-radio-group
            v-model="periodNum"
            size="medium"
            @change="periodNumChange"
          >
            <el-radio-button label="0">最大值</el-radio-button>
            <el-radio-button label="1">最小值</el-radio-button>
            <el-radio-button label="2">平均值</el-radio-button>
            <el-radio-button label="3">合格率</el-radio-button>
          </el-radio-group>
        </div>
        <el-button
          type="primary"
          class="showRollDetail"
          @click="showRollDetailFun"
          v-if="showRollDetail"
          >查看压实过程</el-button
        >

        <div class="typeChart" id="typeChart" v-if="typeChartShow"></div>
        <div class="typeChartHide">暂无数据</div>
      </div>
      <div style="clear: both"></div>
    </div>

    <el-dialog
      width="1600px"
      custom-class="mapdialog"
      :title="dialogTitle"
      :visible.sync="dialogMapVisible"
    >
      <heatMap
        ref="heatmap"
        v-if="dialogMapVisible"
        :chartOption="chartOption"
        :contentShow="false"
      />
      <div class="loadingShow" v-if="loadingShow">加载中...</div>
    </el-dialog>

    <el-dialog
      width="1600px"
      custom-class="mapdialog"
      :title="dialogTitleD"
      :visible.sync="dialogMapVisibleD"
    >
      <div class="ZHSet">
        <span>桩号：</span>
        <span>K</span>
        <el-input
          @input="change($event)"
          type="text"
          v-model="ZHFirst"
        ></el-input>
        <span>+</span>
        <el-input
          @input="change($event)"
          type="text"
          v-model="ZHLast"
        ></el-input>
        <el-button type="primary" @click="getIcvSection">定位</el-button>
      </div>

      <ChartLine :chartOption="chartOptionJ" />

      <div class="loadingShow" v-if="loadingShow">加载中...</div>
    </el-dialog>
  </div>
</template>

<script>
import { unique } from "../../utils/commons";
import {
  getCloudMap,
  getHeatMap,
  getRollerDataAnalysis,
  rollingQualityIcvSection,
} from "../../utils/api";
import heatMap from "../../components/chart/heatMap";
import LeftList from "../../components/layout/leftListT";
import ChartLine from "../../components/chart/line4";
import RollingTrace from "../../pages/quality/part/workPanel/rollingTrace";
import RollLegend from "../../pages/quality/part/rollLegend";
import { dateFormat } from "../../utils/commons.js";
export default {
  name: "app",
  data() {
    return {
      period: "0",
      periodNum: "0",
      duration: "",
      startDate: "",
      endDate: "",
      typeShow: true,
      activeIndex1: 0,
      dialogMapVisible: false,
      dialogMapVisibleD: false,
      chartOption: {},
      chartOptionG: {},

      imageUrl: "",
      rnImageUrl: "", //碾压遍数图
      icvImageUrl: "", //压实度图
      rollingTemperatureImageUrl: "", //碾压温度图
      dialogTitle: "碾压遍数详情",
      dialogTitleD: "压实过程分析",
      loadingShow: true,
      leftData: {},
      keyMap: {},
      typeChart: "",
      unitValue: "遍",
      typeChartShow: false,
      srcList: [],
      showRollDetail: false,
      ZHFirst: "",
      ZHLast: "",
      chartOptionJ: {},
    };
  },
  props: {
    workId: {
      type: String,
      default: function () {
        return "10";
      },
    },
    workName: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    this.typeChart = echarts.init(document.getElementById("typeChart"));
  },
  watch: {
    workId: {
      handler(newVal) {
        // this.getHeatMapFun(newVal, this.period, "", "");
        this.period = 0
        this.typeShow = true
        getCloudMap({ workId: newVal }).then((res) => {
          console.log(res);
          if (res.data.content == null) {
            this.imageUrl = "";
            this.rnImageUrl = "";
            this.icvImageUrl = "";
            this.rollingTemperatureImageUrl = "";
          } else {
            this.imageUrl = JSON.parse(
              JSON.stringify(res.data.content.info.rnImageUrl)
            );
            this.rnImageUrl = res.data.content.info.rnImageUrl;
            this.icvImageUrl = res.data.content.info.icvImageUrl;
            this.rollingTemperatureImageUrl =
              res.data.content.info.rollingTemperatureImageUrl;
          }
          this.srcList = [this.imageUrl];
        });
        this.getHeatMapFun(
          this.workId,
          this.period,
          this.startDate,
          this.endDate
        );
        this.getRollerDataAnalysisFun(
          this.workId,
          this.period,
          this.periodNum,
          this.startDate,
          this.endDate
        );
      },
      deep: true,
    },
  },
  methods: {
    getRnExam(e) {
      console.log("接受setRn_exam", e, this.workId);
      this.$store.commit("setRn_exam", e);
      if (!JSON.parse(localStorage.getItem("setRn_exam"))) {
        localStorage.setItem("setRn_exam", JSON.stringify(e.src));
      }
    },
    getIcvExam(e) {
      console.log("接受setIcv_exam", e, this.workId);
      this.$store.commit("setIcv_exam", e);
      if (!JSON.parse(localStorage.getItem("setIcv_exam"))) {
        localStorage.setItem("setIcv_exam", JSON.stringify(e.src));
      }
    },
    searchBtn() {
      this.getHeatMapFun(
        this.workId,
        this.period,
        this.startDate,
        this.endDate
      );
      this.getRollerDataAnalysisFun(
        this.workId,
        this.period,
        this.periodNum,
        this.startDate,
        this.endDate
      );
    },
    showRollDetailFun() {
      this.dialogMapVisibleD = true;
    },
    change() {
      //console.log(e)
      this.$forceUpdate();
    },
    periodNumChange(e) {
      if (e == 3) {
        this.unitValue = "%";
      } else {
        this.unitValue =
          this.period == "0"
            ? "遍"
            : this.period == "1"
            ? ""
            : this.period == "2"
            ? "℃"
            : "";
      }
      this.periodNum = e;
      this.getRollerDataAnalysisFun(
        this.workId,
        this.period,
        this.periodNum,
        this.startDate,
        this.endDate
      );
    },
    periodChange(e) {
      console.log(e);
      this.period = e;
      this.showRollDetail = false;
      switch (e) {
        case "0":
          this.imageUrl = this.rnImageUrl;
          this.dialogTitle = "碾压遍数详情";
          this.unitValue = "遍";
          break;
        case "1":
          this.imageUrl = this.icvImageUrl;
          this.dialogTitle = "压实度详情";
          this.unitValue = "";
          this.showRollDetail = true;
          break;
        case "2":
          this.imageUrl = this.rollingTemperatureImageUrl;
          this.dialogTitle = "碾压温度详情";
          this.unitValue = "℃";
          break;
        case "3":
          this.typeShow = false;
          this.activeIndex1 = 3;
          break;
      }
      if (e != 3) {
        this.typeShow = true;
        this.getHeatMapFun(
          this.workId,
          this.period,
          this.startDate,
          this.endDate
        );
        this.getRollerDataAnalysisFun(
          this.workId,
          this.period,
          this.periodNum,
          this.startDate,
          this.endDate
        );
      }
      this.srcList = [this.imageUrl];
      console.log(this.imageUrl);
    },
    showDetail() {
      this.dialogMapVisible = true;
      this.loadingShow = true;
      let oriChartOption = JSON.parse(JSON.stringify(this.chartOptionG));
      this.chartOption = {};
      setTimeout(() => {
        this.chartOption = oriChartOption;
        this.loadingShow = false;
      }, 500);
      //   this.getHeatMapFun(
      //     this.workId,
      //     this.period,
      //     this.startDate,
      //     this.endDate
      //   );
    },
    dateChange(e) {
      console.log(e);
      if (e == null) {
        this.startDate = "";
        this.endDate = "";
      } else {
        this.startDate = dateFormat(e[0], "YYYY-MM-DD");
        this.endDate = dateFormat(e[1], "YYYY-MM-DD");
      }
    },
    //获取数据分析
    getRollerDataAnalysisFun(id, type, tab, s, e) {
      let params = {
        workId: id,
        type: type,
        tab: tab,
        startDate: s,
        endDate: e,
      };
      getRollerDataAnalysis(params).then((res) => {
        console.log(res);
        let xData = [];
        let data = [];
        let list = res.data.content.dataList;
        // this.typeChart.dispose()
        if (list.length == 0) {
          this.typeChart.clear();
          this.typeChartShow = false;
        } else {
          this.typeChartShow = true;
          setTimeout(() => {
            for (let i = 0; i < list.length; i++) {
              xData.push(list[i].pileNum);
              data.push(list[i].value);
            }
            let option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                },
              },
              grid: {
                left: 30,
                right: 30,
                top: 30,
                bottom: 35,
              },
              xAxis: {
                type: "category",
                data: xData,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#878787",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
              yAxis: {
                type: "value",
                name: this.unitValue,
                nameTextStyle: {
                  color: "#878787",
                  fontSize: 13,
                },
                // interval: '',
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: ["#F56C6C"],
                  },
                },
                axisLabel: {
                  color: "#878787",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
              dataZoom: [
                {
                  type: "slider",
                  show: true,
                  realtime: true,
                  start: 70,
                  end: 100,
                  handleSize: "10%",
                  height: 10,
                  handleStyle: {
                    borderWidth: 2,
                  },
                  bottom: "0",
                  borderColor: "#F56C6C",
                  fillerColor: "#F56C6C",
                },
                {
                  type: "inside",
                  xAxisIndex: [0],
                },
                {
                  type: "slider",
                  yAxisIndex: [0],
                  show: false,
                  zoomLock: true,
                },
              ],
              series: [
                {
                  data: data,
                  type: "line",
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        color: "#F56C6C",
                      },
                    },
                  },
                },
              ],
            };
            const echarts = require("echarts");
            this.typeChart = echarts.init(document.getElementById("typeChart"));
            this.typeChart.clear();
            this.typeChart.setOption(option);
            // this.typeChart.resize()
          }, 500);
        }

        console.log(this.typeChartShow);
      });
    },
    //获取热力图
    getHeatMapFun(id, t, s, e) {
      let params = {
        workId: id,
        type: t,
        startDate: s,
        endDate: e,
      };
        console.log(t);
      getHeatMap(params).then((r) => {
        console.log(r);
        let res = r.data.content.info;

        this.chartOptionG = this.getChartOption(r, t);
        let set = {};
        switch (t) {
          case 0:
            this.keyMap = {
              max: ["最高遍数"],
              min: ["最低遍数"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
              overRate: ["过压率"],
              lackRate: ["欠压率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2);
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            set.overRate =
              res.overRate == undefined
                ? null
                : (res.overRate * 100).toFixed(2) + "%";
            set.lackRate =
              res.lackRate == undefined
                ? null
                : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
          case '0':
            this.keyMap = {
              max: ["最高遍数"],
              min: ["最低遍数"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
              overRate: ["过压率"],
              lackRate: ["欠压率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2);
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            set.overRate =
              res.overRate == undefined
                ? null
                : (res.overRate * 100).toFixed(2) + "%";
            set.lackRate =
              res.lackRate == undefined
                ? null
                : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
          case "1":
            this.keyMap = {
              max: ["最大值"],
              min: ["最小值"],
              average: ["平均值"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
              overRate: ["过压率"],
              lackRate: ["欠压率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2);
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            set.overRate =
              res.overRate == undefined
                ? null
                : (res.overRate * 100).toFixed(2) + "%";
            set.lackRate =
              res.lackRate == undefined
                ? null
                : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
          case "2":
            this.keyMap = {
              max: ["最高温度"],
              min: ["最低温度"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2) + "℃";
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            // set.overRate =
            //   res.overRate == undefined
            //     ? null
            //     : (res.overRate * 100).toFixed(2) + "%";
            // set.lackRate =
            //   res.lackRate == undefined
            //     ? null
            //     : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
        }

        // let oriChartOption = JSON.parse(JSON.stringify(this.chartOptionG));
        // this.chartOption = {};
        // setTimeout(() => {
        //   this.chartOption = oriChartOption;
        //   this.loadingShow = false;
        // }, 500);
      });
    },
    getChartOption(res, t) {
      let colorBox = [];
      let colorList = [];
      let keys = [];
      let setArr = [];

      if (t == "0") {
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.rollNumColorArr)
        ).reverse();
        colorList = this.$store.state.rollNumColor;

        keys = Object.keys(colorList)
        for (let i = 0; i < keys.length; i++) {
          setArr.push({
            min: keys[i] * 1,
            max: keys[i] * 1,
          });
        }
        setArr[setArr.length - 1].max = 200;
      }else if(t == "1"){
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.icvColorArr)
        ).reverse();
        colorList = this.$store.state.icvColor;

        keys = Object.keys(colorList)
        for(let i=0;i<keys.length;i++){
          setArr.push({
            min: keys[i-1]?keys[i-1]*1+1:0,
            max: keys[i]*1
          })
        }
      }else if(t == "2"){
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.rollColorArr)
        ).reverse();
        colorList = this.$store.state.rollColor;
        keys = Object.keys(colorList)
        for(let i=0;i<keys.length;i++){
          setArr.push({
            min: keys[i-1]?keys[i-1]*1+1:0,
            max: keys[i]*1
          })
        }
      }

      

      
      

      let xAxisData = [];
      let dataG = res.data.content.info.data == null?[0,0,0]: res.data.content.info.data ;
      xAxisData = dataG.map((item) => item[0]);
      let yAxisData = this.$store.state.roadWidth;
      console.log(xAxisData);
      console.log(yAxisData);

      let xAxisObj = {};
      xAxisData = unique(xAxisData);
      for (let i = 0; i < xAxisData.length; i++) {
        xAxisObj[xAxisData[i]] = i;
      }
      let data = [];
      const dataMap = {};
      dataG.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit;
      for (let i = 0; i < dataG.length; i++) {
        let arr = [
          xAxisObj[dataG[i][0]],
          (dataG[i][1] * 10) / (code * 10),
          dataG[i][2],
        ];
        data.push(arr);
      }
      console.log(data);
      let option = {
        visualMap: {
          type: "piecewise",
          min: 0,
          max: 100,
          calculable: true,
          realtime: false,
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          show: false,
          pieces: setArr,
          color: colorBox,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            data: yAxisData,
            splitArea: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              lineStyle: {
                color: "#878787",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "遍数",
            type: "heatmap",
            data: data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
          // {
          //   type: 'line',
          //   data: [['K00+007.51', '11'], ['K00+117', '11'], ['K00+168.3', '2'],['K00+007.51', '2'],['K00+007.51', '11']],
          //   lineStyle:{
          //     color:['#ff0'],
          //     width:2
          //   }

          // }
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10%",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
      };
      return option;
    },

    getIcvSection() {
      let params = {
        pileNum: this.ZHFirst * 1000 + this.ZHLast * 1,
        workId: this.workId,
      };
      rollingQualityIcvSection(params).then((res) => {
        console.log(res);
        let getMap = res.data.content.info.subDataList;
        // let getMap = [
        //   {
        //     name: "第11遍",
        //     subDataMap: {
        //       0: 0.0,
        //       2: 80.0,
        //       4: 70.0,
        //       6: 85.0,
        //       8: 90.0,
        //       10: 95.0,
        //     },
        //   },
        //   {
        //     name: "第11遍",
        //     subDataMap: {
        //       0: 0.0,
        //       2: 80.0,
        //       4: 70.0,
        //       6: 85.0,
        //       8: 90.0,
        //       10: 95.0,
        //     },
        //   },
        // ];
        let getPass = res.data.content.info.passIcv;
        let xAxisList = [];
        if (getMap.length) {
          for (let key in getMap[0].subDataMap) {
            xAxisList.push(key);
          }
        }
        let passVal = [];
        for (let i = 0; i < xAxisList.length; i++) {
          passVal.push(getPass);
        }
        xAxisList = xAxisList.sort(function (x, y) {
          return x - y;
        });
        let series = [];
        series.push({
          name: "合格线",
          type: "line",
          data: passVal,
        });
        for (let i = 0; i < getMap.length; i++) {
          let getList = getMap[i].subDataMap;
          let yData = [];
          for (let key in getList) {
            console.log(key);
            yData.push(getList[key]);
          }
          let setObj = {
            name: getMap[i].name,
            type: "line",
            data: yData,
          };
          series.push(setObj);
        }
        this.$nextTick(() => {
          this.chartOptionJ = Object.assign(
            {},
            {
              dataZoomEnd: Math.min(
                100,
                Math.ceil((8 / xAxisList.length) * 100)
              ),
              legend: {
                orient: "vertical",
                right: 0,
                top: 30,
                itemWidth: 12,
                itemHeight: 8,
                textStyle: {
                  lineHeight: 20,
                },
                padding: 0,
                // data: legend,
              },
              grid: {
                bottom: 70,
                top: 30,
              },
              xAxis: [
                {
                  type: "category",
                  data: xAxisList,
                  splitArea: {
                    show: true,
                  },
                  splitLine: {
                    show: false,
                  },
                  axisLabel: {
                    lineStyle: {
                      color: "#878787",
                    },
                  },
                  axisLine: {
                    lineStyle: {
                      color: "#878787",
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "压实度",
                  splitArea: {
                    show: true,
                  },
                  splitLine: {
                    show: false,
                  },
                  axisLabel: {
                    lineStyle: {
                      color: "#878787",
                    },
                  },
                  axisLine: {
                    lineStyle: {
                      color: "#878787",
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                },
              ],
              dataZoom: [
                {
                  type: "slider",
                  show: true,
                  realtime: true,
                  start: 0,
                  end: 100,
                  handleSize: "10%",
                  height: 10,
                  handleStyle: {
                    borderWidth: 2,
                  },
                  bottom: "5%",
                },
                {
                  type: "inside",
                  xAxisIndex: [0],
                },
                {
                  type: "slider",
                  yAxisIndex: [0],
                  show: false,
                  zoomLock: true,
                },
              ],
              series: series,
            }
          );
          this.loadingShow = false;
        });
      });
    },
  },
  components: {
    heatMap,
    LeftList,
    RollingTrace,
    RollLegend,
    ChartLine,
  },
};
</script>
<style lang="scss">
.mapdialog {
  width: 1520px !important;
  position: relative;
  .el-dialog__header {
    width: 1515px !important;
  }
  .el-dialog__body {
    width: 1515px !important;
    height: 520px !important;
  }
  .loadingShow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.ZHSet {
  .el-input {
    margin: 0 10px;
    width: 120px;
    height: 35px;
    .el-input__inner {
      width: 120px;
      height: 35px;
      border: 1px solid #e1e1e1 !important;
    }
  }
}
</style>
<style lang="scss" scoped="">
.qualityContain {
  width: 100%;
  height: auto;
  //   min-height: 1500px;
  padding-top: 23px;
  padding-bottom: 24px;
  .typeCon {
    width: 100%;
    height: 59px;
  }
  .traceCon {
    width: 100%;
    height: 600px;
  }
  .timeContain {
    width: 100%;
    height: 40px;
  }
  .searchBtn {
    margin-left: 24px;
  }
  .blockHeader {
    width: 100%;
    height: 58px;
    position: relative;
    .redBlock {
      height: 18px;
      width: 4px;
      position: absolute;
      background-color: #e96b5a;
      top: 19px;
      left: 0px;
    }
    .headerText {
      height: 16px;
      line-height: 16px;
      color: #222222;
      display: inline-block;
      position: absolute;
      top: 21px;
      left: 14px;
      font-weight: 500;
      font-size: 16px;
    }
  }
  .imgContent {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    position: relative;
    // background: rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.05);
    .checkDetail {
      width: 80px;
      height: 30px;
      // line-height: 30px;
      font-size: 14px;
      text-align: center;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 99;
    }
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  .infoContain {
    width: 100%;
    height: auto;
    .infoL {
      width: 456px;
      height: auto;
      float: left;
    }
    .infoR {
      width: 1344px;
      height: 280px;
      float: left;
      margin-left: 24px;
      position: relative;
      .typeChart {
        width: 100%;
        height: 224px;
        line-height: 224px;
        text-align: center;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 90;
        background-color: #ffffff;
      }
      .typeChartHide {
        width: 100%;
        height: 224px;
        line-height: 224px;
        text-align: center;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 50;
      }
      .showRollDetail {
        width: 110px;
        height: 30px;
        // line-height: 30px;
        font-size: 14px;
        text-align: center;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 99;
      }
    }
  }
}
.rollLegend {
  position: absolute;
  bottom: 50px;
  left: 0px;
}
</style>